export default __webpack_public_path__ + "static/media/google-play.61ac97c7.svg";